module.exports = __webpack_public_path__ + "static/media/F_icon_reversed.b9cc9857.svg";